import { lazy } from "react";

export const Tabs = lazy(() => import("./Tabs"));
